import React, { useState } from 'react';
import { MdMenu } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';
import "./../styles/NavBar.css";

export default function NavBar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-top-row">
        <div className="navbar-logo-container">
          <img src="assets/logo.png" alt="Logo" className="logoImage" />
        </div>
        <div className="navLinks">
          <Link to="/" className={`link ${location.pathname === '/' ? 'active' : ''}`}>Map</Link>
          <Link to="/readme" className={`link ${location.pathname === '/readme' ? 'active' : ''}`}>ReadMe</Link>
        </div>
        <div className="hamburger-menu-container">
          <button
            className="hamburger-menu-btn"
            aria-label="Open menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <MdMenu size={28} color="#fff" />
          </button>
          {menuOpen && (
            <div className="hamburger-dropdown">
              <Link
                to="/privacypolicy"
                className="dropdown-link"
                onClick={() => setMenuOpen(false)}
              >
                Privacy Policy
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
